import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Empty, Button, Form, Input, Icon, InputNumber, Upload, Select, Popconfirm } from 'antd'
import { infoRequired, validateAgencia, validateNumeroBanco, validateCaracteresUpload, validateAcceptedFormat, validateFileSize } from '../../../utils/validators'
import { gerarAporte } from '../../../redux-flow/actions/contratos'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { faCircle } from '@fortawesome/free-solid-svg-icons'
import attach from '../../../images/attach.png'
import moment from 'moment'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import { gerarRenovacaoComAporte } from '../../../redux-flow/actions/contratos'
import { maskAgenciaOnChange, maskContaOnChange } from '../../../utils/masks';
import { planos } from '../../../constants'
import bancos from '../../Contratos/FormContrato/bancos'

const Option = Select.Option
const { Dragger } = Upload

const LoadingComponent = () => (
    <div style={{ textAlign: 'center' }}>
        <Icon type="loading" />
    </div>
)

class FormRenovacaoAporte extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            file: null,
            valorInput: 0,
            modalRenovacaoOpened: false,
            showInput: false,
            readOnly: true
        }
    }

    handleClick = e => {
        this.setState({
            showInput: true,
            readOnly: false
        })
    }

    beforeUpload = file => {
        this.setState({
            file
        })
        return false
    }

    changeInput = e => {
        this.setState({
            valorInput: e
        })
    }

    componentDidMount() {
        const { onLoad } = this.props
        if (onLoad) {
            onLoad()
        }
    }

    refreshPage() {
        setTimeout(function () {
            window.location.reload()
        }, 4000)
    }

    render() {
        const { isLoading, form, handleSubmit, tipo, userid, contratos, contrato, message, uploadError } = this.props
        let success = this.props.success
        const dateValue = contrato.dataInicio
        const endDateValue = contrato.dataFim
        const codigoBanco = contrato.codigoBanco
        const nomeBanco = contrato.nomeBanco
        const numeroAgencia = contrato.numeroAgencia
        const numeroConta = contrato.numeroConta
        const codigoNomeBanco = [ codigoBanco, nomeBanco ].join(' - ')
        const codigoNomeBancoSeparado = codigoNomeBanco.split(' - ')
        const valorRenovacao = Number(contrato.ValorContratos[0].valorDia) + Number(contratos.filter(status => status.status === 11).map((valor) => valor.Aportes[0].valor).join(''))
        const valorRenovacaoNovo = Number(contrato.Renovacaos[0].valorRenovacao)

        return (
                success ? (
                    <div>
                        <Row>
                            <Col md={7} style={{ margin: 'auto' }}>
                                <div>
                                    <h4 className="tx-pink" style={{ textAlign: 'center' }}><b>Pedido de Renovação Enviado!</b></h4><br />
                                    <p style={{ textAlign: 'center', fontSize: '12px' }}>
                                        Recebemos o seu aporte! Assim que aprovado, o seu novo contrato será gerado e enviado para seu e-mail cadastrado. Verifique sua caixa de entrada, assine e anexe na plataforma.<br />
                                    </p><br />
                                    <Button className="btnGrafico"  onClick={() => { this.props.closeModal() }} style={{ width: '30%', height: '36px', display: 'flex', margin: 'auto', alignItems: 'center', justifyContent: 'center' }}>Fechar</Button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                ) : (
                    <Form className="formContrato" layout="vertical" onSubmit={handleSubmit(form, contrato.status, userid, valorRenovacao, contrato.id, contrato.duracao, this.state.file)}>
                        {
                            !success && message != '' ? (
                                <div class="alert alert-danger fade show notificacao-status">
                                    <p className="mb-0">{message}</p>
                                </div>) : ''
                        }
                        <h4 className="renovacaoTitle">Você optou pela renovação com aporte!</h4><br />
                        <p>Confirme seus dados bancários para seu pedido de renovação com aporte</p>
                        <div>
                            <Row>

                                <Col md={12}>
                                    <p className="tx-pink"><b>Contrato vencido</b></p>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <p className="tx-pink">Produto de Investimento</p>
                                        <p>{tipo === 6 ? ('Flow Digital Assets Spirit') : ('Flow Digital Assets ASA FI')}</p>
                                        <p style={{ visibility: tipo === 6 ? 'hidden' : '' }}>
                                            {tipo === 6 ? '' : contrato.duracao} meses
                                        </p>
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <p className="tx-pink">Valor do contrato</p>
                                    <p>R$ {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(contrato.ValorContratos[0].valorDia)).replace('R$', '')}</p>
                                    {/* <p>R$ {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valorRenovacao).replace('R$', '')}</p> */}
                                </Col>
                                <Col md={4}>
                                    <p className="tx-pink">Data final do contrato</p>
                                    <p>{moment(String(endDateValue)).format('DD/MM/YYYY')}</p>
                                </Col>
                                <hr style={{ width: '90%' }} />

                                <Col md={12}>
                                    <label className="subTitle tx-light-pink">Faça o depósito para a conta {process.env.REACT_APP_NAME}:</label>
                                    <Row>
                                        <Col>
                                            <label className="subTitle tx-light-pink">Banco:</label>
                                            <p>Nu Pagamentos S.A (260)</p>
                                        </Col>
                                        <Col>
                                            <label className="subTitle tx-light-pink">Nome:</label>
                                            <p>Lemon Empreendimentos Eireli</p>
                                        </Col>
                                        <Col>
                                            <label className="subTitle tx-light-pink">CNPJ:</label>
                                            <p>06.979.704/0001-34</p>
                                        </Col>
                                        <Col>
                                            <label className="subTitle tx-light-pink">Agência:</label>
                                            <p>0001</p>
                                        </Col>
                                        <Col>
                                            <label className="subTitle tx-light-pink">Conta:</label>
                                            <p>11378755-7</p>
                                        </Col>
                                    </Row>
                                </Col>

                                <Col md={4}>
                                    <div>
                                        <p className="tx-pink"><b>Aporte</b></p>
                                        <p className="tx-pink">Valor do Aporte</p>
                                        <p>R$ {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(contratos.filter(status => status.status === 11).map((valor) => valor.Aportes[0].valor)).toFixed(2)).replace('R$', '')}</p>
                                    </div>
                                </Col>
                                <>
                        </>
                                <Col md={4}>
                                    <div>
                                        <Form.Item className='meusDados'>
                                        <label className="subTitle tx-light-pink">Envio do comprovante</label>
                                            <br/>
                                        {form.getFieldDecorator('upload', {
                                                rules: [ infoRequired, validateCaracteresUpload(), validateAcceptedFormat(), validateFileSize() ]
                                            })(
                                            <Dragger required beforeUpload={this.beforeUpload} onRemove={() => this.setState({ file: '' })} style={{ paddingBottom: '20px' }}>
                                                <Col>
                                                    <img alt="Ícone upload" src={attach} className="img-fluid" style={{ marginBottom: '10px' }} />
                                                    <label className="tx-pink mb-0">Clique aqui ou arraste e solte seu comprovante</label>
                                                </Col>
                                            </Dragger>
                                            )}
                                            <br/>
                                        </Form.Item>
                                    </div>
                                </Col>
                                <hr style={{ width: '90%' }} />
                                <Col md={12}>
                                    <p className="tx-pink"><b>Contrato novo</b></p>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <p className="tx-pink">Produto de Investimento</p>
                                        <p>{tipo === 6 ? ('Flow Digital Assets Spirit') : ('Flow Digital Assets ASA FI')}</p>
                                        <p style={{ visibility: tipo === 6 ? 'hidden' : '' }}>
                                        {tipo === 6 ? '' : planos[contrato.Renovacaos[0].tipoContratoRenovacao]['meses']} meses
                                        </p>
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <p className="tx-pink">Valor da Renovação</p>
                                    <p>R$ {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valorRenovacaoNovo).replace('R$', '')}</p>
                                </Col>
                                <Col md={4}>
                                    <p className="tx-pink">Data da Renovação</p>
                                    <p>{moment().format('DD/MM/YYYY')}</p>
                                </Col>
                                <hr style={{ width: '90%' }} />
                                <>
                                    <Col md={4}>
                                        <Form.Item label="Banco e código">
                                            {form.getFieldDecorator('codigoBanco', {
                                                rules: [infoRequired],
                                                initialValue: codigoNomeBanco
                                            })(
                                                <Select
                                                    showSearch
                                                    disabled={this.state.readOnly}
                                                >
                                                    {bancos.map(banco => (
                                                        <Option value={banco.name}>{banco.name}</Option>
                                                    ))}
                                                </Select>
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Item label="Agência Bancária (sem dígito)">
                                            {form.getFieldDecorator('agencia', {
                                                rules: [infoRequired, validateAgencia()],
                                                initialValue: numeroAgencia
                                            })(
                                                <Input
                                                    style={{ width: '100%' }}
                                                    placeholder="0000"
                                                    onKeyPress={maskAgenciaOnChange}
                                                    onChange={maskAgenciaOnChange}
                                                    disabled={this.state.readOnly}
                                                />
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Item label="Número da Conta (com dígito)">
                                            {form.getFieldDecorator('conta', {
                                                rules: [infoRequired, validateNumeroBanco()],
                                                initialValue: numeroConta
                                            })(
                                                <Input
                                                    style={{ width: '100%' }}
                                                    placeholder="00000-0"
                                                    onKeyPress={maskContaOnChange}
                                                    onChange={maskContaOnChange}
                                                    disabled={this.state.readOnly}
                                                />
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <div></div>
                                    <br />
                                </>
                            </Row>
                        </div>
                        <Form.Item>
                            {isLoading ? <LoadingComponent /> :
                                <div>
                                    <button
                                        disabled={isLoading}
                                        className="btnGrafico"
                                        htmlType="submit"
                                        style={{
                                            width: '25%',
                                            float: 'right',
                                            position: 'relative',
                                            marginLeft: '20px'
                                        }}
                                        onClick={this.isSuccess}
                                    >
                                        Confirmar
                                    </button>
                                    <Button
                                        className="btnGraficoRenovacao"
                                        style={{
                                            float: 'right',
                                            position: 'relative',
                                            fontWeight: 'bold',
                                            width: '15%'
                                        }}
                                        onClick={this.handleClick}
                                    >
                                        Editar
                                    </Button>
                                </div>}
                        </Form.Item>
                    </Form>
                )
        )
    }
}

const mapStateToProps = state => ({
    logMessage: state.contratos.message,
    isLoading: state.contratos.isLoading,
    success: state.contratos.success,
    userid: state.login.userid,
    contratos: state.contratos.contratos,
    values: state.contratos.values,
    message: state.contratos.message
})

const mapDispatchToProps = dispatch => ({
    handleSubmit: (form, status, idCliente, valorRenovacao, idContrato, duracao, comprovante) => e => {
        e.preventDefault()
        dispatch(gerarRenovacaoComAporte(form, status, idCliente, valorRenovacao, idContrato, duracao, comprovante))
    }
})

export default Form.create({ name: 'create-aporte' })(
    connect(mapStateToProps, mapDispatchToProps)(FormRenovacaoAporte)
)